var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.199951 7.99995C0.199951 3.69254 3.69254 0.199951 7.99995 0.199951C12.3074 0.199951 15.8 3.69254 15.8 7.99995C15.8 12.3074 12.3074 15.8 7.99995 15.8C3.69254 15.8 0.199951 12.3074 0.199951 7.99995ZM14.5999 7.99995C14.5999 4.35528 11.6446 1.39995 7.99995 1.39995C4.35528 1.39995 1.39995 4.35528 1.39995 7.99995C1.39995 11.6446 4.35528 14.5999 7.99995 14.5999C11.6446 14.5999 14.5999 11.6446 14.5999 7.99995Z",
    fill: "#00A8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15637 6.3042C8.46013 6.3042 8.71117 6.52992 8.7509 6.82278L8.75637 6.9042V11.4433C8.75637 11.7747 8.48775 12.0433 8.15637 12.0433C7.85262 12.0433 7.60158 11.8176 7.56185 11.5247L7.55637 11.4433L7.55585 7.50385L6.9042 7.5042C6.60044 7.5042 6.34941 7.27848 6.30968 6.98562L6.3042 6.9042C6.3042 6.60044 6.52992 6.34941 6.82278 6.30968L6.9042 6.3042H8.15637Z",
    fill: "#00A8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87819 11.0205C10.2096 11.0205 10.4782 11.2891 10.4782 11.6205C10.4782 11.9243 10.2525 12.1753 9.95961 12.215L9.87819 12.2205H6.43472C6.10335 12.2205 5.83472 11.9519 5.83472 11.6205C5.83472 11.3168 6.06044 11.0657 6.3533 11.026L6.43472 11.0205H9.87819Z",
    fill: "#00A8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00006 3.38257C7.43817 3.38257 6.98267 3.83807 6.98267 4.39996C6.98267 4.96185 7.43817 5.41735 8.00006 5.41735C8.56195 5.41735 9.01745 4.96185 9.01745 4.39996C9.01745 3.83807 8.56195 3.38257 8.00006 3.38257Z",
    fill: "#00A8C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.963fd6fd66214a91bfb9d6c06ce26583.svg";
export { ForwardRef as ReactComponent };